import { render, staticRenderFns } from "./AgentItem.vue?vue&type=template&id=8bdcaf24&scoped=true&"
import script from "./AgentItem.vue?vue&type=script&lang=js&"
export * from "./AgentItem.vue?vue&type=script&lang=js&"
import style0 from "./AgentItem.vue?vue&type=style&index=0&id=8bdcaf24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdcaf24",
  null
  
)

export default component.exports